import request from '../utils/request';

const isProduction = !window.location.host.includes('test') && !window.location.port.includes('8080');
// 区分线上和测试环境
const BASE = isProduction
  ? 'https://jzjx.classba.cn/dlapi'
  : 'https://jzjx-test.classba.cn/dlapi'; // 测试环境
const BigUrl = isProduction
  ? 'https://gx.classba.cn'
  : 'https://gx.test.classba.cn'; // 测试环境
// const BASE = 'https://jzjx-test.classba.cn/dlapi';
const baseURL = '/mtapi/api';
const BASE_URL = '/ucapi';
export default {
  // 登录
  LoginData(params) {
    return request.post({
      url: `${BASE_URL}/user/login`,
      data: params,
    });
  },
  // 登录
  getMenuList(params) {
    return request.post({
      url: `${BASE_URL}/menu/getMenuList`,
      data: params,
    });
  },
  // 获取测评列表
  getTestInfo(params) {
    return request.post({
      url: `${BASE_URL}/task/getTaskList`,
      data: params,
    });
  },
  // 获取学生登陆后信息
  getStuInfoAfterLogin(params) {
    return request.post({
      url: `${BASE_URL}/task/getStuInfoAfterLogin`,
      data: params,
    });
  },
  // 获取单个学生列表(1测评 2预习 3练习) toB前端
  getStuTaskListById(params) {
    return request.post({
      url: `${BASE_URL}/task/getTaskListById`,
      data: params,
    });
  },
  // 退出登录
  logOut() {
    return request.post({
      url: `${BASE_URL}/user/logout`,
    });
  },
  // 学生测评token信息
  getStuTaskTokenInfo(params) {
    return request.post({
      url: `${BASE_URL}/task/study`,
      data: params,
    });
  },
  // 开始测评
  testStart(params) {
    return request.post({
      url: `${BASE_URL}/home/api/teststart`,
      data: params,
    });
  },
  // 获取最后一次信息
  getLastInfo(params) {
    return request.post({
      url: `${BASE_URL}/task/getlastinfo`,
      data: params,
    });
  },
  // token登录
  tokenLogin(params) {
    return request.post({
      url: `${BASE}/home/logintoken`,
      data: params,
    });
  },
  // 知识点视频预习列表
  getPreviewList(params) {
    return request.post({
      url: `${baseURL}/literature/sheetVideo`,
      data: params,
    });
  },
  // 知识点视频预习进度
  videoProgressUpdate(params) {
    return request.post({
      url: `${baseURL}/videoProgressUpdate`,
      data: params,
    });
  },
  // mt登录
  mtLogin(params) {
    return request.post({
      url: `${baseURL}/login`,
      data: params,
    });
  },
  // dd token登录
  loginByDd() {
    return request.post({
      url: `${BASE_URL}/user/loginByDd`,
    });
  },
  // 北斗登录
  getOpenJumpLink(params) {
    return request.post({
      url: `${BigUrl}/gxapi/user/getOpenJumpLink`,
      data: params,
    });
  },
};
